<template>
  <RouterLink
    class="odd:bg-gray-100 border border-gray-200 rounded px-4 flex-1 hover:border-gray-800"
    :to="{
      name: 'accounts.show',
      params: {
        accountId: account.id,
      },
    }"
  >
    <div class="flex -mx-4 justify-between items-center">
      <div class="flex-1 p-4">
        <div class="flex flex-col lg:flex-row items-start lg:items-center -mx-4">
          <div class="flex-none w-24 px-4">
            <template v-if="account.logo">
              <img :src="account.logo" class="block rounded w-full" />
            </template>
            <template v-else>
              <div class="aspect-ratio-square w-full rounded bg-gray-200" />
            </template>
          </div>
          <div class="flex-1 px-4">
            <h5 class="text-sm">
              {{ account.name }}
            </h5>
            <p class="text-xs text-gray-600">
              <span>{{ account.email }}</span>
              &bull;
              <span>{{ account.phone }}</span>
            </p>
          </div>

          <div class="hidden lg:block w-48 lg:text-right px-4">
            <p class="text-xs text-gray-600">
              {{ account.createdAt }}
            </p>
            <p class="hidden lg:block text-xs text-gray-600">
              <span>{{ account.createdAtDiffForHumans }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </RouterLink>
</template>

<script>
export default {
  name: 'ClientListLine',
  props: {
    account: { type: Object, required: true },
  },
};
</script>
